<template>
  <div>Casino Group item</div>
</template>

<script>
export default {
  name: 'casinoGameGroup',
  props: [],
  components: {},
  data () {
    return {}
  },
  computed: {},
  methods: {},
  mounted () {}
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoGameGroup.vue